module.exports = "pegasus_template/assets/blocks/column-1-theme5.png";